<template>
  <div class="podcast-page">
    <div class="uk-section">
      <div class="uk-container uk-container-large">
        <div class="podcast-header">
          <h2 class="podcast-header__title">voices of the pandemic</h2>
          <div class="podcast-header__content">
            <img class="podcast-header__logo" :src="podcastLogo" />
            <div class="podcast-header__text-container">
              <p class="podcast-header__text">
                Voices of the Pandemic is a six-part podcast series hosted by
                former award-winning broadcast journalist Calvin To. Ever since
                the COVID-19 pandemic arrived in Canada, there has been a surge
                in anti-Asian racism across the country. In this podcast you
                will hear the stories from the people who have experienced it
                first-hand.
              </p>
              <p class="podcast-header__text">
                Calvin To is a first generation Chinese Canadian whose family
                immigrated from Hong Kong in the 1970s. Now a law student at
                Osgoode Hall Law School in Toronto, he has a former career as a
                broadcast journalist for TV stations in Ontario, Saskatchewan,
                and British Columbia. He is passionate about issues of human
                rights and equity. Calvin produced this podcast while
                volunteering with the Chinese Canadian National Council of
                Toronto (CCNCTO) in the summer of 2020.
              </p>
            </div>
          </div>
        </div>
        <!-- Podcast Player List -->
        <div class="podcast-player_container">
          <div
            v-for="data in podcastData"
            :key="data.src"
            class="podcast-player_item"
          >
            <p class="podcast-player_title">{{ data.title }}</p>
            <iframe
              :src="data.src"
              width="100%"
              height="170"
              frameborder="0"
              allowtransparency="true"
              allow="encrypted-media"
            ></iframe>
            <p class="podcast-player_subtext">
              {{ data.text }}
              <span class="podcast-player_subtext__warning">{{
                data.subText
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const logoImage = require("@/assets/images/podcast_logo.jpg");
const PODCAST_DATA = [
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/3lB0x3Td5zDhbj1ncIwkxR",
    title: "Episode 1 - Derek Lang",
    text:
      "In this premiere episode of Voices of the Pandemic, our host Calvin To speaks with Derek Lang, a visual effects photographer based in Toronto who has travelled the world making Hollywood movies. Derek tells us about his family history and a racist encounter that happened back in March of 2020.",
    subText:
      "Content Warning: harsh language, racial slurs, mention of harassment",
  },
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/7BFuVozWhbzPHfOvGcj4ks",
    title: "Episode 2 - Ian Hood",
    text:
      "In this episode, our host Calvin To speaks with Ian Hood about how he has handled the pandemic as a biracial person, and how his family's Japanese Canadian roots played into the racist encounters he's experienced. Ian works for the Red Cross with disaster and emergency management.",
    subText:
      "Content Warning: mention of racial slurs, derogatory terms, internment camps",
  },
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/5msJhIicdSaXidpUiMY0nb",
    title: "Episode 3 - KJ",
    text:
      "In this episode, our guest KJ talks about a racist experience that happened to her and the students she advises in an online classroom during the pandemic. She also shares with us her journey of leaving China to settle in Canada to raise a family and to freely practice her faith.",
    subText: "Content Warning: mention of racist encounters",
  },
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/70HVe02iAuiweHYIjByEap",
    title: "Episode 4 - Pak Kei Wong",
    text:
      "Calvin speaks with Pak Kei Wong in this episode, a teacher and HR professional in Montreal. Pak Kei courageously shares with us multiple instances of racism he encountered throughout 2020. Beginning earlier in the year with micro-aggressions on public transit to being yelled at with racist comments on the street.",
    subText: "Content Warning: mentions of racist encounters",
  },
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/2qeLwkY8yHeAkAyaoOxQPs",
    title: "Episode 5 - David Chan",
    text:
      "Our guest in this week's episode is David Chan. He bravely recalls a violent and racist encounter that occurred back in March of 2020 in the lobby of his building. David also talks about how his family was burdened by the exorbitant Chinese head tax in the 1960s, and how it is rooted in anti-Asian racism dating back to the 1800s.",
    subText:
      "Content Warning: racial violence, physical assault, Chinese head tax, harsh language",
  },
  {
    src:
      "https://open.spotify.com/embed-podcast/episode/45XOLYm6zLy6cCkdbTBYc1",
    title: "Episode 6 - Connie Lee",
    text:
      "For the final episode of this podcast series, our guest is Connie Lee who works for the City of Toronto. Connie talks about how anti-Asian sentiment has been prevalent in her life since childhood, and how it has been exacerbated during the Pandemic. She sheds some light on the racism she experienced before and during the initial lockdown, particularly about food and the impact on Asian businesses.",
    subText: "Content Warning: mentions of racist encounters, harsh language",
  },
];

export default {
  name: "PodcastPage",
  data() {
    return {
      podcastData: PODCAST_DATA,
      podcastLogo: logoImage,
      soundCloudSrc:
        "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1149741355&color=%23fcf515&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true",
    };
  },
};
</script>
<style lang="css">
.podcast-page {
  height: 100%;
}

.podcast-header {
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  padding-left: 100px;
  padding-right: 100px;
  align-self: center;
}

.podcast-header__title {
  text-transform: uppercase;
  font-weight: 600;
  word-spacing: 2px;
  color: black;
}

.podcast-header__content {
  padding-top: 30px;
  padding-left: 30px;
  margin-bottom: 50px;
  display: flex;
}

.podcast-header__logo {
  height: 280px;
}

.podcast-header__text-container {
  display: flex;
  padding-left: 50px;
  padding-right: 50px;
  flex-direction: column;
}

.podcast-header__text {
  color: black;
  font-family: "Nunito", sans-serif;
}

.podcast-player_container {
  display: flex;
  flex-direction: column;
  padding-left: 100px;
  padding-right: 100px;
  align-self: center;
}

.podcast-player_subtext {
  margin: 0;
  font-size: 14px;
}

.podcast-player_subtext__warning {
  font-weight: bold;
  font-style: italic;
}

.podcast-player_title {
  text-transform: uppercase;
  font-weight: bold;
  color: black;
  font-size: 20px;
  margin: 0;
  margin-bottom: 10px;
}

.podcast-player_item {
  padding-top: 30px;
}

@media only screen and (max-width: 1100px) {
  .podcast-header__logo {
    width: 200px;
    height: 200px;
  }
}

@media only screen and (max-width: 850px) {
  .podcast-header__content {
    flex-direction: column;
    padding-left: 10px;
    padding-right: 10px;
  }
  .podcast-header__logo {
    align-self: center;
    margin-bottom: 50px;
  }

  .podcast-header__text-container {
    display: flex;
    padding: 0;
    flex-direction: column;
  }

  .podcast-header {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
    align-self: center;
  }

  .podcast-player_container {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
    padding-right: 10px;
    align-self: center;
  }
}

@media only screen and (max-width: 700px) {
  .podcast-header__title {
    font-size: 30px !important;
  }
}
</style>
